import { motion } from "framer-motion";
import { useEffect, useState } from "react";

const links = [
  { id: "company", label: "Company" },
  { id: "focus", label: "Focus" },
  { id: "science", label: "Science" },
  { id: "pipeline", label: "Pipeline" },
  { id: "platforms", label: "Platforms" },
  { id: "contact", label: "Contact" },
];

export const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const scrollTo = (id) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <motion.header
      initial={{ y: -32, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.6, ease: "easeOut" }}
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? "py-3" : "py-5"
      }`}
      data-testid="site-navbar"
    >
      <div className={`mx-auto max-w-7xl px-5 sm:px-8 ${scrolled ? "" : ""}`}>
        <div
          className={`flex items-center justify-between rounded-full px-4 sm:px-6 py-3 transition-all ${
            scrolled ? "glass-strong" : "bg-transparent border border-transparent"
          }`}
        >
          <button
            data-testid="nav-logo"
            onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
            className="flex items-center gap-3 group whitespace-nowrap"
            aria-label="Blude Life Science and Tech - Home"
          >
            <span className="relative inline-flex items-center justify-center w-10 h-10 rounded-full bg-gradient-to-br from-[#E60000] to-[#8B0000] overflow-hidden shrink-0">
              <span className="absolute inset-0 rounded-full bg-[#E60000] opacity-50 blur-md group-hover:opacity-90 transition" />
              <img
                src="/assets/yqe0kve0_Symbol.png"
                alt="Blude symbol"
                className="relative w-7 h-7 object-contain invert brightness-200"
                draggable="false"
              />
            </span>
            <span className="font-display font-semibold tracking-tight text-white text-[14px] sm:text-[15px] whitespace-nowrap">
              Blude{" "}
              <span className="text-blude-textDim font-normal tracking-[0.04em]">
                Life Science and Tech
              </span>
            </span>
          </button>

          <nav className="hidden md:flex items-center gap-1">
            {links.map((l) => (
              <button
                key={l.id}
                onClick={() => scrollTo(l.id)}
                data-testid={`nav-link-${l.id}`}
                className="px-4 py-2 text-[13px] tracking-wide text-blude-textDim hover:text-white transition-colors rounded-full hover:bg-white/5"
              >
                {l.label}
              </button>
            ))}
          </nav>

          <button
            data-testid="nav-cta-contact"
            onClick={() => scrollTo("contact")}
            className="btn-primary !py-2.5 !px-5 text-[13px]"
          >
            <span className="dot-pulse" /> Get in Touch
          </button>
        </div>
      </div>
    </motion.header>
  );
};

